import React from "react";

/**
 * Capability card — used on Building Materials / Consulting / Real Estate grids.
 * Smaller and lighter than DivisionCard.
 */
export const CapabilityCard = ({
    icon: Icon,
    title,
    description,
    className = "",
    "data-testid": testId,
}) => {
    return (
        <div
            className={`zen-card group relative flex h-full flex-col rounded-2xl border border-border-subtle bg-elevated p-7 ${className}`}
            data-testid={testId}
        >
            <div className="flex h-11 w-11 items-center justify-center rounded-lg border border-border-subtle bg-[var(--bg-elevated-2)]">
                {Icon && (
                    <Icon
                        className="h-4.5 w-4.5 text-[var(--accent)]"
                        strokeWidth={1.5}
                    />
                )}
            </div>
            <h3 className="mt-6 font-display text-[18px] font-semibold leading-tight text-text-primary">
                {title}
            </h3>
            <p className="mt-2 text-[14.5px] leading-[1.65] text-text-secondary">
                {description}
            </p>
        </div>
    );
};

export default CapabilityCard;
